import { useState } from "react";
import s from "../../common.module.css";
import { Comment } from "../Comment";
import { MyPdfViewer } from "@common/Probes/Probes";

export const ShowMode = ({ state, file, ...props }) => {
  const [showComment, setShowComment] = useState(false);

  return (
    <>
      <MyPdfViewer file={process.env.REACT_APP_PATH_FILE + file} />

      {!showComment && (
        <div className={s.showBottom}>
          <button className="btn" onClick={() => setShowComment(!showComment)}>
            Перейти к результатам
          </button>
        </div>
      )}

      {showComment && <Comment state={state} />}
    </>
  );
};